import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import plugins from './plugins';
import { state } from './state';

import webPanel from '@/core/shared/web-panel/store';

import auth from '@/core/shared/auth/store';

import organization from '@/core/shared/vuex-modules/organization';
import locale from '@/core/shared/vuex-modules/locale';
import timer from '@/core/shared/vuex-modules/timer';
import health from '@/core/shared/vuex-modules/health/health-check-module';

import location from '@/store/location';
import experience from '@/store/experience';
import station from '@/store/station';
import booking from '@/store/booking';
import stationTemporaryClosing from '@/store/stationTemporaryClosing';
import content from '@/store/content';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins,
  modules: {
    webPanel,

    auth,

    organization,
    locale,
    timer,
    health,

    location,
    experience,
    station,
    booking,
    stationTemporaryClosing,
    content,
  },
});

if (module.hot) {
  module.hot.accept([
    './getters',
    './actions',
    './mutations',
  ], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations'),
      modules: {
        webPanel: require('@/core/shared/web-panel/store'),

        auth: require('@/core/shared/auth/store'),

        organization: require('@/core/shared/vuex-modules/organization'),
        locale: require('@/core/shared/vuex-modules/locale'),
        timer: require('@/core/shared/vuex-modules/timer'),
        health: require('@/core/shared/vuex-modules/health/health-check-module'),

        location: require('@/store/location'),
        experience: require('@/store/experience'),
        station: require('@/store/station'),
        booking: require('@/store/booking'),
        stationTemporaryClosing: require('@/store/stationTemporaryClosing'),
        content: require('@/store/content'),
      },
    });
  });
}

export default store;

export function useStore () {
  return store;
}
